import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { TransitTaskStatusEnum } from '@zaoblako/shared/modules/cctv/enums/transit-task/transit-task-status.enum';

export const TransitTaskStatusI18nEnum: Record<I18nLocalesEnum, Record<TransitTaskStatusEnum, string>> = {
  [I18nLocalesEnum.RU_RU]: {
    [TransitTaskStatusEnum.NEW]: 'Новая',
    [TransitTaskStatusEnum.IN_PROCESS]: 'Въезд',
    [TransitTaskStatusEnum.COMPLETED]: 'Выезд',
  },
  [I18nLocalesEnum.EN_US]: {
    [TransitTaskStatusEnum.NEW]: 'New',
    [TransitTaskStatusEnum.IN_PROCESS]: 'In process',
    [TransitTaskStatusEnum.COMPLETED]: 'Completed',
  }
}
